import { BASE_URL, ENDPOINT_URL } from "../../config/urlConfig";
import { ApiService } from "../../config/apiServices";
import { encryptJsonPayload, getPublicKey } from "../../utils/encryption";

/**
 * Utility: encrypt payload then POST. Falls back to plain POST on error.
 */
const encryptedPost = async (methodUrl, data) => {
  try {
    const publicKey = getPublicKey();

    if (publicKey) {
      const encryptedPayload = await encryptJsonPayload(data, publicKey);
      return ApiService.post(methodUrl, encryptedPayload);
    }

    console.warn("No public key found - sending unencrypted data");
    return ApiService.post(methodUrl, data);
  } catch (error) {
    console.error("Encryption error:", error);
    return ApiService.post(methodUrl, data);
  }
};

export const GlobalSearchApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.global_search?.main_search;
  return encryptedPost(METHOD_URL, data);
};

// Elements Files and Folder API
export const ElementsFolderFileApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.elements?.folder_files;
  return encryptedPost(METHOD_URL, data);
};

// Elements Category API
export const ElementsCategoryApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.elements?.folder_files;
  return encryptedPost(METHOD_URL, data);
};

// Elements Document API
export const ElementsFolderDocumentApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.elements?.document_details;
  return encryptedPost(METHOD_URL, data);
};

// SideBar API
export const ElementsSidebarApi = () => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.elements?.left_side_bar;
  return encryptedPost(METHOD_URL, {});
};

export const CategoryApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.elements?.Category;
  return encryptedPost(METHOD_URL, data);
};
